module.exports = __webpack_public_path__ + "img/savology-wf-5.fbf0adaf.jpg";